const PASSWORD_PLACEHOLDER = "__TINES_POSTGRES_PASSWORD__";
const DEFAULT_PORT = "5432";
const DEFAULT_DATABASE = "postgres";

function hostComponent(host: string | undefined) {
  const value = (host ?? "").trim();
  if (/^\[[0-9a-fA-F:.]+\]$/.test(value)) return value;
  if (!/^[A-Za-z0-9.-]+$/.test(value)) {
    throw new Error("Invalid Postgres host");
  }
  return value;
}

function portComponent(port: string | undefined) {
  const value = (port || DEFAULT_PORT).trim();
  if (!/^\d+$/.test(value)) throw new Error("Invalid Postgres port");
  const portNumber = Number(value);
  if (portNumber < 1 || portNumber > 65535) {
    throw new Error("Invalid Postgres port");
  }
  return value;
}

function databaseComponent(database: string | undefined) {
  return database?.trim() || DEFAULT_DATABASE;
}

export function postgresConnectionString(
  { host, port, username, database, tls }: Record<string, string>,
  forceTls = false
) {
  const postgresHost = hostComponent(host);
  const postgresPort = portComponent(port);
  const postgresDatabase = databaseComponent(database);
  const encodedUsername = encodeURIComponent(username ?? "");
  const params = new URLSearchParams();
  if (forceTls || tls === "true") params.set("sslmode", "require");
  const query = params.size > 0 ? `?${params}` : "";
  return `postgresql://${encodedUsername}:${PASSWORD_PLACEHOLDER}@${postgresHost}:${postgresPort}/${encodeURIComponent(postgresDatabase)}${query}`;
}

export const postgresConnectionFields = [
  {
    kind: "input",
    label: "Host",
    required: true,
    placeholder: "database.cluster-abc123.us-east-1.rds.amazonaws.com",
    target: { kind: "configuration", field: "host" },
  },
  {
    kind: "input",
    label: "Port",
    required: true,
    defaultValue: DEFAULT_PORT,
    target: { kind: "configuration", field: "port" },
  },
  {
    kind: "input",
    label: "Database",
    required: true,
    defaultValue: DEFAULT_DATABASE,
    target: { kind: "configuration", field: "database" },
  },
  {
    kind: "input",
    label: "Username",
    required: true,
    target: { kind: "configuration", field: "username" },
  },
] as const;
